/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_TitleInputs */

const en_hero_title = /** @type {(inputs: Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the inside out.`)
};

/**
* | output |
* | --- |
* | "From the inside out." |
*
* @param {Hero_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hero_title = /** @type {((inputs?: Hero_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hero_title(inputs)
});